import React, { useEffect, useMemo } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { CenterDataForm } from '../../../../app/models/Center';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';

type Props = {
  centerDataForm: CenterDataForm;
  setCenterDataForm: (data: CenterDataForm) => void;
  disabled?: boolean;
  errorFields?: any;
  societiesOpts?: { id: number | string; name: string }[];
};

const CenterForm = ({
  centerDataForm,
  setCenterDataForm,
  disabled = false,
  errorFields,
  societiesOpts = [],
}: Props) => {
  const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

  useEffect(() => { setErrors(errorFields); }, [errorFields, setErrors]);

  // [{id,name}] -> [{value,label}]
  const societyOptions = useMemo(
    () => SelectTwoMapperOptions(societiesOpts, 'id', ['name']),
    [societiesOpts]
  );

  // Opción seleccionada (igualando tipos por seguridad)
  const selectedSociety = useMemo(() => {
    if (centerDataForm.society_id == null) return null;
    return (
      societyOptions.find(opt => String(opt.value) === String(centerDataForm.society_id)) ?? null
    );
  }, [societyOptions, centerDataForm.society_id]);

  const handleChangeInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setCenterDataForm({ ...centerDataForm, [name]: value });
  };

  return (
    <>
      <div className="mb-2 row">
        {/* Sociedad */}
        <div className="col-md-12">
          <label className="col-form-label">Sociedad</label>
          <SelectTwo
            id="society_id"
            name="society_id"
            inputValue={centerDataForm.society_id ?? null}
            options={societyOptions}
            onChange={(opt: any) => {
              const newSocietyId = Array.isArray(opt) ? undefined : opt?.value;
              setCenterDataForm({
                ...centerDataForm,
                society_id: newSocietyId != null ? Number(newSocietyId) : undefined,
              });
            }}
            disabled={disabled}
            placeholder="Seleccione sociedad"
            isClearable={false}
            hasError={!!fieldErrorMessage('society_id')}
            onFocus={() => onFocusRemove('society_id')}
          />
          <div className="invalid-feedback" style={{ display: 'flex' }}>
            {fieldErrorMessage('society_id')}
          </div>
        </div>

        {/* Nombre */}
        <div className="col-md-12">
          <label className="col-form-label">Nombre</label>
          <input
            name="name"
            id="name"
            type="text"
            className={`form-control ${fieldHasError('name')}`}
            value={centerDataForm.name ?? ''}
            onChange={handleChangeInput}
            onFocus={() => onFocusRemove('name')}
            placeholder="Ingrese nombre"
            disabled={disabled}
          />
          <div className="invalid-feedback" style={{ display: 'flex' }}>
            {fieldErrorMessage('name')}
          </div>
        </div>

        {/* Dirección */}
        <div className="col-md-12">
          <label className="col-form-label">Dirección</label>
          <input
            name="address"
            id="address"
            type="text"
            className={`form-control ${fieldHasError('address')}`}
            value={centerDataForm.address ?? ''}
            onChange={handleChangeInput}
            onFocus={() => onFocusRemove('address')}
            placeholder="Ingrese dirección"
            disabled={disabled}
          />
          <div className="invalid-feedback" style={{ display: 'flex' }}>
            {fieldErrorMessage('address')}
          </div>
        </div>
      </div>
    </>
  );
};

export default CenterForm;
